
export enum ConversationSourceCd {
	INSPECTIONS_CNV = 'Inspections-CNV',
	LINEHAUL_CNV = 'Linehaul-CNV',
	PICKUP_REQUEST_CNV = 'PickupRequest-CNV',
	PN_D_CNV = 'PnD-CNV',
	RADER_CNV = 'Rader-CNV'}
